import { useEffect } from 'react';
import {
  INote,
  IGenerateRequest,
  IResponseTranscript,
} from '../global/interfaces';
import { IDelta } from '@homeporter/types';
import { getChunks } from '../utils/helpers';

interface UseProcessFormProps {
  booking: any; // TODO: Add proper type
  documentSection: any; // TODO: Add proper type
  context: string;
  transcriptSegments: any[]; // TODO: Add proper type
  transcriptAttachments: Record<string, any[]>; // TODO: Add proper type
  setGenerateRequest: (request: any) => void; // TODO: Add proper type
  selectedModel: string;
  regenerateIndex: number | undefined;
  setRegenerateIndex: (_?: number | undefined) => void;
  responseTranscript: IResponseTranscript | null;
  setTranscriptSegments: (segments: any[]) => void;
  setScrollTo: (scrollTo: string | undefined) => void;
  resetAttachments: (
    bookingId: number | undefined,
    transcriptAttachments: Record<string, (IDelta | INote)[]>,
  ) => void;
  generateRequest: IGenerateRequest | undefined;
}

export const useProcessTranscript = ({
  booking,
  documentSection,
  context,
  transcriptSegments,
  transcriptAttachments,
  setGenerateRequest,
  selectedModel,
  regenerateIndex,
  setRegenerateIndex,
  responseTranscript,
  setTranscriptSegments,
  setScrollTo,
  resetAttachments,
  generateRequest,
}: UseProcessFormProps) => {
  useEffect(() => {
    if (!booking?.booking_id || regenerateIndex !== -1) return;
    console.log(':::::regenerateIndex transcript:', regenerateIndex);

    //deleteAINotes(transcriptAttachments);
    //setTranscriptSegments([...transcriptSegments]);
    const chunks = getChunks(transcriptSegments, 50);
    const model = selectedModel.toLowerCase().replaceAll(' ', '-');
    /*
    (transcriptAttachments[`note-${transcriptSegments[0].time}`] ??= []).push({
      title: 'AI Transcript Analyzer',
      description: `Model: ${model}\nDate: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
      idx: transcriptAttachments[`note-${transcriptSegments[0].time}`].length,
      src: 'a',
    });
    */
    setGenerateRequest({
      bookingId: booking.booking_id,
      regenerateIndex,
      model,
      type: 'Transcript',
      chunks,
      index: 0,
      context,
    });
  }, [regenerateIndex]);

  useEffect(() => {
    if (generateRequest === undefined) setRegenerateIndex(undefined);
  }, [generateRequest]);

  useEffect(() => {
    if (
      !responseTranscript ||
      !documentSection ||
      regenerateIndex === undefined ||
      generateRequest?.chunks === undefined ||
      generateRequest.index === undefined
    )
      return;

    const currentChunk = generateRequest.chunks?.[generateRequest.index];
    /*
    (transcriptAttachments[`note-${currentChunk.timestamp}`] ??= []).push({
      title: 'AI Summarized',
      description: responseTranscript.cleanedTranscript,
      idx: transcriptAttachments[`note-${currentChunk.timestamp}`].length,
      src: 'a',
    });

    (transcriptAttachments[`note-${currentChunk.timestamp}`] ??= []).push({
      title: 'AI Context',
      description: responseTranscript.context,
      idx: transcriptAttachments[`note-${currentChunk.timestamp}`].length,
      src: 'a',
    });
    */
    const model = selectedModel.toLowerCase().replaceAll(' ', '-');
    (transcriptAttachments[`note-${currentChunk.timestamp}`] ??= []).push({
      title: `Model: ${model}, Date: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
      description: `Summary: ${responseTranscript.cleanedTranscript}\nContext: ${responseTranscript.context}`,
      idx: transcriptAttachments[`note-${currentChunk.timestamp}`].length,
      src: 'a',
    });
    setTranscriptSegments([...transcriptSegments]);
    setScrollTo(`note-${currentChunk.timestamp}`);

    //if (generateRequest.index < 3) {
    if (generateRequest.index < 2) {
      //generateRequest.chunks?.length - 1 || 0) {
      console.log(':::::generateRequest.index:', generateRequest.index);

      setGenerateRequest({
        ...generateRequest,
        index: generateRequest.index + 1,
        context: responseTranscript.context,
      });
    } else {
      resetAttachments(booking?.booking_id, transcriptAttachments);
      setScrollTo(undefined);
      setGenerateRequest(undefined);
    }
  }, [responseTranscript]);
};
